<template>
  <div class="overview-page-header">
    <div class="userID_sp">ユーザーID：{{ userID }}</div>
    <div class="overview-page-header-container">
      <h1>気象情報概況</h1>
      <select name="area" v-model="selectedFlightAreaId">
        <option v-for="area in flightAreas" :key="area.flight_area_id" :value="area.flight_area_id">
          {{ area.flight_area_name }}
        </option>
      </select>
      <div class="userID_pc">ユーザーID：{{ userID }}</div>
      <div class="button-hamburger" id="hamburger">
        <img
          src="../../assets/images/icon/button_hamburger.svg"
          alt=""
          aria-label="メニューボタン"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, computed, onUnmounted } from 'vue'
import { useUserStore } from '@/stores/user'
import { useFlightAreaStore } from '@/stores/flightArea'
import { setupGlobalNavMenu } from '@/composables/openMainMenu'

const flightAreaStore = useFlightAreaStore()

const flightAreas = computed(() => flightAreaStore.flightAreas)

const selectedFlightAreaId = computed<number | null>({
  get: () => flightAreaStore.selectedFlightAreaId,
  set: (val) => {
    if (val != null) {
      flightAreaStore.setSelectedFlightArea(val)
    }
  },
})

// ユーザーID
const user = useUserStore()
const userID = computed(() => user.userInfo?.login_name ?? '')

let cleanup: (() => void) | undefined

onMounted(async () => {
  await flightAreaStore.fetchFlightAreas()

  const first = flightAreas.value[0]
  const selectedId = flightAreaStore.selectedFlightAreaId
  const exists = flightAreas.value.some((area) => area.flight_area_id === selectedId)

  if ((!selectedId || !exists) && first) {
    // ストアで選択されている飛行エリアが無効なら、先頭の飛行エリアを選択する
    flightAreaStore.setSelectedFlightArea(first.flight_area_id)
  }

  cleanup = setupGlobalNavMenu() || undefined
})

onUnmounted(() => {
  cleanup?.()
})
</script>
